import posthog from 'posthog-js'

export default function (title: string, field: string | null): void {
  posthog.capture(title, {
    field
  })
}
